"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketActivityApply = require("@/api/marketActivityApply");
var _marketActivity = require("@/api/marketActivity");
var _auth = require("@/utils/auth");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MarketActivityApplyAdd',
  data: function data() {
    return {
      isEdit: false,
      // 是否为编辑模式
      editId: null,
      // 编辑的ID
      submitLoading: false,
      privacyAgreed: false,
      privacyDialog: false,
      disclaimerDialog: false,
      activityOptions: [],
      currentActivity: null,
      formConfig: null,
      basicFormFields: [],
      dynamicFormFields: [],
      fieldOrder: ['salesType', 'goods', 'goodsImg', 'needCount', 'businessFoodLicense', 'healthCertificate', 'name', 'phone', 'wechat', 'wechatPhoto', 'address', 'introduce', 'stallIntroduce', 'activityRecord', 'deviceInfo', 'maxKw', 'idCard', 'idCardPhoto'],
      applyForm: {
        uid: 0,
        activityId: '',
        salesType: '',
        goods: '',
        name: '',
        phone: '',
        wechat: '',
        idCard: '',
        idCardPhoto: '',
        address: '',
        goodsImg: '',
        wechatPhoto: '',
        businessFoodLicense: '',
        healthCertificate: '',
        maxKw: null,
        needCount: null,
        introduce: '',
        stallIntroduce: '',
        activityRecord: '',
        deviceInfo: '',
        privacyStatus: 0
      },
      applyRules: {
        activityId: [{
          required: true,
          message: '请选择活动',
          trigger: 'change'
        }],
        salesType: [{
          required: true,
          message: '请选择销售类型',
          trigger: 'change'
        }],
        goods: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        wechat: [{
          required: true,
          message: '请输入微信号',
          trigger: 'blur'
        }],
        idCard: [{
          required: true,
          message: '请输入身份证号',
          trigger: 'blur'
        }, {
          pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
          message: '请输入正确的身份证号',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请输入常住地址',
          trigger: 'blur'
        }],
        introduce: [{
          required: true,
          message: '请输入自我介绍',
          trigger: 'blur'
        }],
        stallIntroduce: [{
          required: true,
          message: '请输入摊位名或品牌名',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    pageTitle: function pageTitle() {
      return this.isEdit ? '编辑活动报名' : '添加活动报名';
    }
  },
  watch: {
    'applyForm.salesType': function applyFormSalesType(newVal) {
      var _this = this;
      this.$nextTick(function () {
        if (_this.$refs.applyForm) {
          ['businessFoodLicense', 'healthCertificate'].forEach(function (fieldName) {
            _this.$refs.applyForm.validateField(fieldName, function () {});
          });
        }
      });
    }
  },
  created: function created() {
    // 判断是否为编辑模式
    if (this.$route.query.id) {
      this.isEdit = true;
      this.editId = this.$route.query.id;
    }
    this.getActivityOptions();

    // 如果是编辑模式，加载数据
    if (this.isEdit) {
      this.loadEditData();
    } else {
      // 初始化时显示所有默认字段
      this.showAllDefaultFields();
    }
  },
  methods: {
    // 获取活动选项
    getActivityOptions: function getActivityOptions() {
      var _this2 = this;
      (0, _marketActivity.marketActivityList)({
        page: 1,
        limit: 1000,
        status: 0
      }).then(function (response) {
        _this2.activityOptions = response.list || [];
        // 若路由带有activityId，则在选项加载后预选中
        var qId = _this2.$route && _this2.$route.query ? _this2.$route.query.activityId : null;
        if (qId != null) {
          // 与选项id类型对齐
          var sample = _this2.activityOptions && _this2.activityOptions.length > 0 ? _this2.activityOptions[0].id : null;
          var normalized = sample != null && typeof sample === 'number' ? Number(qId) : String(qId);
          _this2.applyForm.activityId = normalized;
          // 触发联动逻辑，加载活动详情与表单配置
          _this2.handleActivityChange(_this2.applyForm.activityId);
        }
      }).catch(function (error) {
        console.error('获取活动列表失败:', error);
        _this2.$message.error('获取活动列表失败');
      });
    },
    // 加载编辑数据
    loadEditData: function loadEditData() {
      var _this3 = this;
      (0, _marketActivityApply.marketActivityApplyInfo)(this.editId).then(function (response) {
        // 填充表单数据
        Object.keys(_this3.applyForm).forEach(function (key) {
          if (response[key] !== undefined && response[key] !== null) {
            _this3.applyForm[key] = response[key];
          }
        });

        // 设置隐私政策同意状态
        _this3.privacyAgreed = response.privacyStatus === 0;

        // 如果有活动ID，触发活动变化处理，以加载对应的表单配置
        if (response.activityId) {
          _this3.handleActivityChange(response.activityId);
        }
      }).catch(function (error) {
        console.error('加载报名数据失败:', error);
        _this3.$message.error('加载报名数据失败');
      });
    },
    // 活动选择变化
    handleActivityChange: function handleActivityChange(value) {
      if (value) {
        var activity = this.activityOptions.find(function (item) {
          return item.id === value;
        });
        if (activity) {
          this.applyForm.marketId = activity.marketId;
          this.applyForm.merId = activity.merId;
        }
        // 获取活动详情和表单配置
        this.getActivityDetail(value);
      } else {
        // 清除活动选择，显示所有默认字段
        this.showAllDefaultFields();
      }
    },
    // 显示所有默认字段
    showAllDefaultFields: function showAllDefaultFields() {
      var _this4 = this;
      this.basicFormFields = [];
      this.dynamicFormFields = [];

      // 所有默认字段的完整映射
      var allDefaultFields = {
        'sales_type': {
          name: 'salesType',
          label: '销售类型',
          type: 'select'
        },
        'goods': {
          name: 'goods',
          label: '商品名称',
          type: 'text'
        },
        'name': {
          name: 'name',
          label: '姓名',
          type: 'text'
        },
        'phone': {
          name: 'phone',
          label: '手机号',
          type: 'phone'
        },
        'wechat': {
          name: 'wechat',
          label: '微信号',
          type: 'text'
        },
        'id_card': {
          name: 'idCard',
          label: '身份证',
          type: 'idCard'
        },
        'id_card_photo': {
          name: 'idCardPhoto',
          label: '身份证图片',
          type: 'image'
        },
        'address': {
          name: 'address',
          label: '常住地址',
          type: 'text'
        },
        'introduce': {
          name: 'introduce',
          label: '一句话自我介绍',
          type: 'textarea'
        },
        'stall_introduce': {
          name: 'stallIntroduce',
          label: '摊位名或品牌名',
          type: 'textarea'
        },
        'activity_record': {
          name: 'activityRecord',
          label: '活动经历',
          type: 'textarea'
        },
        'device_info': {
          name: 'deviceInfo',
          label: '用电设备描述',
          type: 'textarea'
        },
        'max_kw': {
          name: 'maxKw',
          label: '用电设备最大功率单位W',
          type: 'number',
          min: 1
        },
        'goods_img': {
          name: 'goodsImg',
          label: '商品图片和摆台图',
          type: 'image'
        },
        'wechat_photo': {
          name: 'wechatPhoto',
          label: '微信二维码',
          type: 'image'
        },
        'business_food_license': {
          name: 'businessFoodLicense',
          label: '营业执照或食品经营许可证',
          type: 'image'
        },
        'health_certificate': {
          name: 'healthCertificate',
          label: '健康证',
          type: 'image'
        },
        'need_count': {
          name: 'needCount',
          label: '申请摊位数',
          type: 'number',
          min: 1
        }
      };

      // 显示所有默认字段
      Object.keys(allDefaultFields).forEach(function (fieldKey) {
        var field = allDefaultFields[fieldKey];
        _this4.basicFormFields.push(_objectSpread(_objectSpread({}, field), {}, {
          required: true
        }));

        // 添加到表单数据中
        if (!_this4.applyForm.hasOwnProperty(field.name)) {
          var fieldType = _this4.getFieldType(field);
          var defaultValue = _this4.getFieldDefaultValue(fieldType);
          _this4.applyForm[field.name] = defaultValue;
        }

        // 添加到验证规则中
        _this4.applyRules[field.name] = [_this4.buildRequiredRule(field)];

        // 添加特定字段的验证规则
        if (field.type === 'phone') {
          _this4.applyRules[field.name].push({
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的手机号',
            trigger: 'blur'
          });
        } else if (field.type === 'idCard') {
          _this4.applyRules[field.name].push({
            pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: '请输入正确的身份证号',
            trigger: 'blur'
          });
        }
      });
      this.sortFieldsByOrder(this.basicFormFields);
    },
    // 获取活动详情
    getActivityDetail: function getActivityDetail(activityId) {
      var _this5 = this;
      (0, _marketActivity.marketActivityInfo)(activityId).then(function (response) {
        _this5.currentActivity = response;
        // 解析setting字段中的表单配置
        try {
          if (response.setting) {
            _this5.formConfig = typeof response.setting === 'string' ? JSON.parse(response.setting) : response.setting;
          } else {
            _this5.formConfig = {};
          }
        } catch (error) {
          console.error('解析表单配置失败:', error);
          _this5.formConfig = {};
        }
        _this5.generateDynamicForm();

        // 设置活动相关信息
        _this5.applyForm.marketId = response.marketId;
        _this5.applyForm.merId = response.merId;
      }).catch(function (error) {
        console.error('获取活动详情失败:', error);
        _this5.$message.error('获取活动详情失败');
      });
    },
    // 生成动态表单
    generateDynamicForm: function generateDynamicForm() {
      var _this6 = this;
      if (!this.formConfig) return;
      this.basicFormFields = [];
      this.dynamicFormFields = [];

      // 预定义的基础字段映射
      var basicFieldMap = {
        'goods': {
          name: 'goods',
          label: '商品名称',
          type: 'text'
        },
        'name': {
          name: 'name',
          label: '姓名',
          type: 'text'
        },
        'phone': {
          name: 'phone',
          label: '手机号',
          type: 'phone'
        },
        'wechat': {
          name: 'wechat',
          label: '微信号',
          type: 'text'
        },
        'id_card': {
          name: 'idCard',
          label: '身份证',
          type: 'idCard'
        },
        'id_card_photo': {
          name: 'idCardPhoto',
          label: '身份证图片',
          type: 'image'
        },
        'address': {
          name: 'address',
          label: '常住地址',
          type: 'text'
        },
        'introduce': {
          name: 'introduce',
          label: '一句话自我介绍',
          type: 'textarea'
        },
        'stall_introduce': {
          name: 'stallIntroduce',
          label: '摊位名或品牌名',
          type: 'textarea'
        },
        'activity_record': {
          name: 'activityRecord',
          label: '活动经历',
          type: 'textarea'
        },
        'device_info': {
          name: 'deviceInfo',
          label: '用电设备描述',
          type: 'textarea'
        },
        'max_kw': {
          name: 'maxKw',
          label: '用电设备最大功率单位W',
          type: 'number',
          min: 1
        },
        'goods_img': {
          name: 'goodsImg',
          label: '商品图片和摆台图',
          type: 'image'
        },
        'wechat_photo': {
          name: 'wechatPhoto',
          label: '微信二维码',
          type: 'image'
        },
        'business_food_license': {
          name: 'businessFoodLicense',
          label: '营业执照或食品经营许可证',
          type: 'image'
        },
        'health_certificate': {
          name: 'healthCertificate',
          label: '健康证',
          type: 'image'
        },
        'need_count': {
          name: 'needCount',
          label: '申请摊位数',
          type: 'number',
          min: 1
        },
        'sales_type': {
          name: 'salesType',
          label: '销售类型',
          type: 'select'
        }
      };

      // 遍历配置中的字段
      Object.keys(this.formConfig).forEach(function (fieldKey) {
        var isRequired = _this6.formConfig[fieldKey];
        if (isRequired) {
          // 检查是否是基础字段
          if (basicFieldMap[fieldKey]) {
            // 基础字段
            var basicField = _objectSpread(_objectSpread({}, basicFieldMap[fieldKey]), {}, {
              required: true
            });
            _this6.basicFormFields.push(basicField);

            // 添加到表单数据中
            var fieldName = basicField.name;
            if (!_this6.applyForm.hasOwnProperty(fieldName)) {
              var fieldType = _this6.getFieldType(basicField);
              _this6.applyForm[fieldName] = _this6.getFieldDefaultValue(fieldType);
            }

            // 添加到验证规则中
            _this6.applyRules[fieldName] = [_this6.buildRequiredRule(basicField)];

            // 添加特定字段的验证规则
            if (basicField.type === 'phone') {
              _this6.applyRules[fieldName].push({
                pattern: /^1[3-9]\d{9}$/,
                message: '请输入正确的手机号',
                trigger: 'blur'
              });
            } else if (basicField.type === 'idCard') {
              _this6.applyRules[fieldName].push({
                pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                message: '请输入正确的身份证号',
                trigger: 'blur'
              });
            }
          } else {
            // 动态字段（不在预定义映射中的字段）
            var dynamicField = {
              name: fieldKey,
              label: _this6.getFieldLabelFromKey(fieldKey),
              type: 'text',
              required: true
            };
            _this6.dynamicFormFields.push(dynamicField);

            // 添加到表单数据中
            if (!_this6.applyForm.hasOwnProperty(fieldKey)) {
              var _fieldType = _this6.getFieldType(dynamicField);
              _this6.applyForm[fieldKey] = _this6.getFieldDefaultValue(_fieldType);
            }

            // 添加到验证规则中
            _this6.applyRules[fieldKey] = [_this6.buildRequiredRule(dynamicField)];
          }
        }
      });
      this.sortFieldsByOrder(this.basicFormFields);
    },
    // 根据字段键获取标签
    getFieldLabelFromKey: function getFieldLabelFromKey(key) {
      var labelMap = {
        'goods': '商品名称',
        'name': '姓名',
        'phone': '手机号',
        'wechat': '微信号',
        'id_card': '身份证',
        'id_card_photo': '身份证图片',
        'address': '常住地址',
        'introduce': '一句话自我介绍',
        'stall_introduce': '摊位名或品牌名',
        'activity_record': '活动经历',
        'device_info': '用电设备描述',
        'max_kw': '用电设备最大功率单位W',
        'goods_img': '商品图片',
        'wechat_photo': '微信二维码',
        'business_food_license': '营业执照或食品经营许可证',
        'health_certificate': '健康证',
        'need_count': '申请摊位数',
        'sales_type': '销售类型'
      };
      return labelMap[key] || key;
    },
    // 获取字段名称
    getFieldName: function getFieldName(field) {
      return field.name || field.fieldName || field.key;
    },
    // 获取字段标签
    getFieldLabel: function getFieldLabel(field) {
      return field.label || field.fieldLabel || field.title || field.displayName;
    },
    // 获取字段类型
    getFieldType: function getFieldType(field) {
      return field.type || field.fieldType || field.inputType || 'text';
    },
    // 根据字段类型获取默认值
    getFieldDefaultValue: function getFieldDefaultValue(type) {
      if (type === 'checkbox') {
        return [];
      }
      if (type === 'number') {
        return null;
      }
      return '';
    },
    // 构建必填校验规则
    buildRequiredRule: function buildRequiredRule(field) {
      var _this7 = this;
      var type = this.getFieldType(field);
      var label = this.getFieldLabel(field);
      var fieldName = this.getFieldName(field);
      if (['businessFoodLicense', 'healthCertificate'].includes(fieldName)) {
        return {
          validator: function validator(rule, value, callback) {
            if (_this7.applyForm.salesType === 0) {
              var images = _this7.normalizeImageList(_this7.applyForm[fieldName]);
              if (!images.length) {
                callback(new Error("\u8BF7\u4E0A\u4F20".concat(label)));
                return;
              }
            }
            callback();
          },
          trigger: 'change'
        };
      }
      var trigger = 'blur';
      var action = '请输入';
      if (['select', 'radio', 'checkbox', 'date'].includes(type)) {
        trigger = 'change';
        action = '请选择';
      } else if (type === 'image') {
        trigger = 'change';
        action = '请上传';
      } else if (type === 'number') {
        trigger = 'change';
      }
      return {
        required: true,
        message: "".concat(action).concat(label),
        trigger: trigger
      };
    },
    // 统一解析图片字段
    normalizeImageList: function normalizeImageList(value) {
      if (!value) return [];
      if (Array.isArray(value)) {
        return value.map(function (item) {
          return typeof item === 'string' ? item.trim() : item;
        }).filter(function (item) {
          return item !== undefined && item !== null && String(item).trim() !== '';
        });
      }
      if (typeof value === 'string') {
        var trimmed = value.trim();
        if (!trimmed) return [];
        try {
          var parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) {
            return parsed.map(function (item) {
              return typeof item === 'string' ? item.trim() : item;
            }).filter(function (item) {
              return item !== undefined && item !== null && String(item).trim() !== '';
            });
          }
        } catch (error) {
          // ignore parse error
        }
        if (trimmed.includes(',')) {
          return trimmed.split(',').map(function (item) {
            return item.trim();
          }).filter(function (item) {
            return item;
          });
        }
        return [trimmed];
      }
      return [];
    },
    // 根据定义顺序排序字段
    sortFieldsByOrder: function sortFieldsByOrder(fields) {
      var _this8 = this;
      if (!Array.isArray(fields) || fields.length === 0) return fields;
      var orderMap = this.fieldOrder.reduce(function (acc, key, index) {
        acc[key] = index;
        return acc;
      }, {});
      fields.sort(function (a, b) {
        var aIndex = orderMap[_this8.getFieldName(a)] !== undefined ? orderMap[_this8.getFieldName(a)] : Number.MAX_SAFE_INTEGER;
        var bIndex = orderMap[_this8.getFieldName(b)] !== undefined ? orderMap[_this8.getFieldName(b)] : Number.MAX_SAFE_INTEGER;
        return aIndex - bIndex;
      });
      return fields;
    },
    triggerImageFieldValidate: function triggerImageFieldValidate(fieldName) {
      var _this9 = this;
      this.$nextTick(function () {
        if (_this9.$refs.applyForm) {
          _this9.$refs.applyForm.validateField(fieldName, function () {});
        }
      });
    },
    // 获取图片列表
    getImageList: function getImageList(field) {
      var fieldName = this.getFieldName(field);
      return this.normalizeImageList(this.applyForm[fieldName]);
    },
    // 打开图片选择弹窗
    openImageModal: function openImageModal(field) {
      var _this0 = this;
      var fieldName = this.getFieldName(field);
      var currentImages = this.getImageList(field);
      var remainingSlots = 9 - currentImages.length;
      this.$modalUpload(function (img) {
        if (!img) return;

        // 如果是多选，将新选择的图片添加到现有数组中
        var newImages = img.map(function (item) {
          return item.sattDir;
        });
        var totalImages = currentImages.length + newImages.length;
        if (totalImages > 9) {
          _this0.$message.warning('最多只能上传9张图片，已自动截取前' + remainingSlots + '张');
          var finalImages = [].concat(_toConsumableArray(currentImages), _toConsumableArray(newImages.slice(0, remainingSlots)));
          _this0.applyForm[fieldName] = JSON.stringify(finalImages);
        } else {
          var _finalImages = [].concat(_toConsumableArray(currentImages), _toConsumableArray(newImages));
          _this0.applyForm[fieldName] = JSON.stringify(_finalImages);
        }
        if (_this0.getFieldType(field) === 'image') {
          _this0.triggerImageFieldValidate(fieldName);
        }
      }, true,
      // 多选模式
      'activity' // 图片类型
      );
    },
    // 移除图片
    removeImage: function removeImage(field, index) {
      var fieldName = this.getFieldName(field);
      var currentImages = this.getImageList(field);
      currentImages.splice(index, 1);
      this.applyForm[fieldName] = JSON.stringify(currentImages);
      if (this.getFieldType(field) === 'image') {
        this.triggerImageFieldValidate(fieldName);
      }
    },
    // 显示隐私政策
    showPrivacyPolicy: function showPrivacyPolicy() {
      this.privacyDialog = true;
    },
    // 显示免责声明
    showDisclaimer: function showDisclaimer() {
      this.disclaimerDialog = true;
    },
    // 提交报名
    submitApply: function submitApply() {
      var _this1 = this;
      // 检查隐私政策同意
      if (!this.privacyAgreed) {
        this.$message.error('请先同意隐私政策和平台免责声明');
        return;
      }
      this.applyForm.privacyStatus = this.privacyAgreed ? 0 : 1;
      this.$refs.applyForm.validate(function (valid) {
        if (valid) {
          _this1.submitLoading = true;
          var submitData = _objectSpread({}, _this1.applyForm);

          // 如果不是编辑模式，设置默认待审核状态
          if (!_this1.isEdit) {
            submitData.applyStatus = 0;
          }

          // 如果是编辑模式，添加ID
          if (_this1.isEdit) {
            submitData.id = _this1.editId;
          }

          // 根据是否为编辑模式调用不同的API
          var apiMethod = _this1.isEdit ? _marketActivityApply.marketActivityApplyUpdate : _marketActivityApply.marketActivityApplySave;
          apiMethod(submitData).then(function (response) {
            _this1.$message.success(_this1.isEdit ? '修改成功' : '报名提交成功，请等待审核');
            _this1.submitLoading = false;
            _this1.goBack();
          }).catch(function (error) {
            console.error((_this1.isEdit ? '修改' : '报名提交') + '失败:', error);
            _this1.$message.error((_this1.isEdit ? '修改' : '报名提交') + '失败');
            _this1.submitLoading = false;
          });
        }
      });
    },
    // 重置表单
    resetForm: function resetForm() {
      var _this10 = this;
      this.$refs.applyForm.resetFields();
      this.privacyAgreed = false;

      // 重置基础表单字段
      this.basicFormFields.forEach(function (field) {
        var fieldName = _this10.getFieldName(field);
        var fieldType = _this10.getFieldType(field);
        _this10.applyForm[fieldName] = _this10.getFieldDefaultValue(fieldType);
      });

      // 重置动态表单字段
      this.dynamicFormFields.forEach(function (field) {
        var fieldName = _this10.getFieldName(field);
        var fieldType = _this10.getFieldType(field);
        _this10.applyForm[fieldName] = _this10.getFieldDefaultValue(fieldType);
      });
    },
    // 返回
    goBack: function goBack() {
      this.$router.go(-1);
    }
  }
};